// extracted by mini-css-extract-plugin
export default {"outerspace":"Outerspace_outerspace__K+1OU","spacetravel":"Outerspace_spacetravel__7vDEg"};